import { cn } from "@omni/utils/styles";

import { useECommerceContext } from "@/components/Product/ECommerce/context/eCommerce.context";
import { useProductConfigurationContext } from "@/components/Product/ECommerce/context/productConfiguration.context";

type Props = {
    className?: string;
};

const ProductConfiguration = ({ className }: Props) => {
    const {
        productConfiguration,
        setIsConfigurationValid,
        configuration,
        setConfiguration
    } = useProductConfigurationContext();

    const { paintConfiguratorPath, product } = useECommerceContext();

    const onConfigurationChange = (config: Partial<any>) =>
        setConfiguration((currentConfig: any) => ({
            ...currentConfig,
            ...config
        }));

    if (!productConfiguration) return null;

    return (
        <productConfiguration.visual
            className={cn(className)}
            metaConfiguration={{
                paintConfiguratorPath: paintConfiguratorPath || undefined,
                product: product
            }}
            configuration={configuration}
            setConfigurationValid={setIsConfigurationValid}
            onConfigurationChange={onConfigurationChange}
        />
    );
};

export { ProductConfiguration };
